// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"RoleScreen_buttonsContainer__TUfWA","button":"RoleScreen_button__DZ11K"};